import { PlansAndPricesParamEnum } from '../queryParamParserService/plansAndPricesQueryParams.service';
import {
  deepLinkActions,
  isCategoryValid,
  isFieldValid,
  isFieldValueValid,
  isLocationValid,
} from './deepLink.models';

const DEEPLINK_FULL = 'deepLinkFullLocation';

class DeepLink {
  public actions: deepLinkActions;

  init() {
    if (window.location.search) {
      const query = new URLSearchParams(window.location.search);
      const location = query.get('deepLinkLocation');
      const category = query.get('deepLinkCategory');
      const field = query.get('deepLinkField');
      const fieldValue = query.get('deepLinkFieldValue');

      this.actions = {
        deepLinkLocation: isLocationValid(location) ? location : null,
        deepLinkCategory: isCategoryValid(category) ? category : null,
        deepLinkField: isFieldValid(field) ? field : null,
        deepLinkFieldValue: isFieldValueValid(fieldValue) ? fieldValue : null,
      };

      if (location || category || field || fieldValue || this.isValidParams(query)) {
        localStorage.setItem(DEEPLINK_FULL, window.location.pathname + window.location.search);
      }
    }
  }

  /**
   * Extracts the contractId from path /myOrders/123456 or /ARE-25610//myOrders/123456
   */
  extractContractIdFromPath(pathname: string): number | null {
    const splitPath = pathname.split('/');
    if (splitPath.length === 3 && splitPath[1] === 'myOrders') {
      const contractId = parseInt(splitPath[2], 10);
      return !Number.isNaN(contractId) ? contractId : null;
    }
    return null;
  }

  /**
   * Retrieves the contractId from the stored deeplink URL
   */
  getContractId(): number | null {
    const storedUrl = localStorage.getItem(DEEPLINK_FULL);
    if (storedUrl) {
      // Extract pathname from stored URL (format: /myOrders/123456?deepLinkCategory=...)
      const pathname = storedUrl.split('?')[0];
      return this.extractContractIdFromPath(pathname);
    }
    return null;
  }

  //whitelisted params. Required to set up the deeplink URL in registration flow
  isValidParams(query: any) {
    let isValid = false;
    const residencetype = query.get(PlansAndPricesParamEnum.RESIDENT_TYPE);
    const zipcode = query.get(PlansAndPricesParamEnum.ZIP_CODE);
    const sellerscoverage = query.get(PlansAndPricesParamEnum.SELLERS_COVERAGE);

    if (residencetype || zipcode || sellerscoverage) {
      isValid = true;
    }

    return isValid;
  }

  /** Must be called by the consumer once it is completed using this service. Failure to do so will result in unwanted behavior. */
  reset() {
    this.actions = {
      deepLinkLocation: null,
      deepLinkCategory: null,
      deepLinkField: null,
      deepLinkFieldValue: null,
    };

    localStorage.removeItem(DEEPLINK_FULL);
  }

  GetDeepLinkString() {
    return localStorage.getItem(DEEPLINK_FULL);
  }

  getCategory(): string | null {
    return this.actions?.deepLinkCategory || this.getStoredCategory();
  }

  private getStoredCategory(): string | null {
    const storedDeepLink = localStorage.getItem('deepLinkFullLocation');
    if (!storedDeepLink) return null;

    const queryString = storedDeepLink.split('?')[1];
    return queryString ? new URLSearchParams(queryString).get('deepLinkCategory') : null;
  }
}

const DeepLinkService = new DeepLink();
export default DeepLinkService;
